import React, { Component } from 'react';

import { cloudinaryURLFromImage } from '../util/cloudinaryImageUtil'

class Image extends Component {

  constructor(props) {
    super(props);

    this.alt = props.alt || '';
    if (props.img) {
      this.srcset = ``;
      this.src = cloudinaryURLFromImage(props.img);
    } else this.src = props.imageSrc || '';
  }

  // max img width 1440
  // 1280
  // 800?
  // 360?
  render() {
    return (
      <div>
        <img alt={this.alt} src={this.src} srcSet={this.srcset} />
      </div>
    );
  }
}

export default Image;


// WEBPACK FOOTER //
// ./src/components/CloudinaryImage.js